import { IconMap } from '../../../shared/sprite';
import { DEFAULT_SORT_ITEMS } from '../../../shared/ui/select';

export const SORT_ITEMS = {
  lastModified: { glyph: IconMap.Edit03, label: 'Last modified' },
  ...DEFAULT_SORT_ITEMS,
  mostViewed: { glyph: IconMap.Eye, label: 'Most viewed' },
} as const;

export const FILTER_PAGE_ITEMS = {
  allPages: { glyph: IconMap.Files, label: 'All pages' },
  published: { glyph: IconMap.FileCheck03, label: 'Published' },
  notPublished: { glyph: IconMap.FileMinus03, label: 'Not published' },
} as const;

export const QUICK_BUTTON_ITEMS = [
  {
    glyph: IconMap.PhoneOutgoing01,
    id: 'create-follow-up',
    label: 'Create follow-up',
    className:
      'text-warning-500 bg-warning-50 group-hover:text-warning-600 group-hover:bg-warning-100',
  },
  {
    glyph: IconMap.Briefcase01,
    id: 'build-business-case',
    label: 'Build business case',
    className:
      'text-blue-400 bg-blue-dark-50 group-hover:text-blue-600 group-hover:bg-blue-dark-100',
  },
  {
    glyph: IconMap.VideoRecorder,
    id: 'record-video-recap',
    label: 'Record video recap',
    className:
      'text-success-500 bg-success-50 group-hover:text-success-600 group-hover:bg-success-100',
  },
  {
    glyph: IconMap.BarChartSquare01,
    id: 'track-engagement',
    label: 'Track engagement',
    className:
      'text-blue-400 bg-blue-dark-50 group-hover:text-blue-600 group-hover:bg-blue-dark-100',
  },
  {
    glyph: IconMap.LayersThree01,
    id: 'clone-winning-template',
    label: 'Clone winning template',
    className:
      'text-success-500 bg-success-50 group-hover:text-success-600 group-hover:bg-success-100',
  },
  {
    glyph: IconMap.CheckVerified02,
    id: 'build-deal-room',
    label: 'Build deal room',
    className:
      'text-fuchsia-500 bg-fuchsia-50 group-hover:text-fuchsia-600 group-hover:bg-fuchsia-100',
  },
  {
    glyph: IconMap.OnePage,
    id: 'make-executive-brief',
    label: 'Make executive brief',
    className:
      'text-warning-500 bg-warning-50 group-hover:text-warning-600 group-hover:bg-warning-100',
  },
  {
    glyph: IconMap.DataFlow03,
    id: 'design-action-plan',
    label: 'Design action plan',
    className:
      'text-fuchsia-500 bg-fuchsia-50 group-hover:text-fuchsia-600 group-hover:bg-fuchsia-100',
  },
];
